import React from "react";

const StartScreen = ({ numQuestions, dispatch }) => {
  return (
    <div className="start">
      <h2>Welcome to the React Quiz!!</h2>
      <h3> {numQuestions} questions to test your React Mastery </h3>
      <button
        onClick={() => dispatch({ type: "start", status: "active" })}
        className="btn btn-ui"
      >
        {" "}
        Let's Start{" "}
      </button>
    </div>
  );
};

export default StartScreen;
